import { DynamicObjectInterface } from '../type';
import { AxiosUtilsType, axiosGet, axiosPost, axiosPut, axiosPatch } from './axiosUtils';
import './axiosInterceptor';

const EnrollmentService = {
  async getEnrollmentList(enrollmentType?: string, campaignId?: string): AxiosUtilsType {
    if (campaignId) {
      return await axiosGet(`enrollment/list?enrollmentType=${enrollmentType}&campaignId=${campaignId}`);
    } else {
      return await axiosGet(`enrollment/list?enrollmentType=${enrollmentType}`);
    }
  },
  async getEnrollmentDetails(selectedRowId: string): AxiosUtilsType {
    return await axiosGet(`enrollment/list/${selectedRowId}`);
  },
  async deleteEnrollment(selectedRowId: string): AxiosUtilsType {
    return await axiosPatch(`enrollment/list/${selectedRowId}`);
  },
  async createEnrollment(enrollment: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`enrollment/create`, enrollment);
  },
  async updateEnrollment(selectedRowId: string, enrollment: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPut(`enrollment/list/${selectedRowId}`, enrollment);
  },
  async getExportEnrollmentCsv(enrollmentType?: string): AxiosUtilsType {
    return await axiosGet(`/enrollment/export/csv?enrollmentType=${enrollmentType}`);
  },
};
export default EnrollmentService;
